module.exports = __webpack_public_path__ + "img/antes_despues_157.eb363a06.png";